module.exports = __webpack_public_path__ + "img/404.13b8fd2b.png";